<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card shadow-lg rounded">
        <div class="card-header text-center bg-dark text-primary">
          <h3>{{ 'PASSWORD_UPDATE_TITLE' | translate }}</h3>
        </div>
        <div class="card-body">
          @if (email) {
            <form [formGroup]="resetForm" novalidate>
              <!-- Old Password -->
              <div class="mb-3">
                <label for="oldPassword" class="form-label">{{ 'OLD_PASSWORD' | translate }}</label>
                <div class="input-group">
                  <input
                    [type]="showOldPassword ? 'text' : 'password'"
                    formControlName="oldPassword"
                    id="oldPassword"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': isSubmitted && formControls['oldPassword'].invalid }"
                  />
                  <button
                    type="button"
                    class="btn btn-outline-secondary eye-slash-btn"
                    (click)="toggleOldPasswordVisibility()"
                    tabindex="-1"
                  >
                    <i class="bi" [ngClass]="showOldPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                  </button>
                </div>
                @if (formControls['oldPassword'].dirty && formControls['oldPassword'].invalid) {
                  <div class="invalid-feedback d-block">
                    {{ 'PASSWORD_REQUIRED' | translate }}
                  </div>
                }
              </div>

              <!-- New Password -->
              <div class="mb-3">
                <label for="password" class="form-label">{{ 'NEW_PASSWORD' | translate }}</label>
                <div class="input-group">
                  <input
                    [type]="showNewPassword ? 'text' : 'password'"
                    formControlName="password"
                    id="password"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': isSubmitted && formControls['password'].invalid }"
                  />
                  <button
                    type="button"
                    class="btn btn-outline-secondary eye-slash-btn"
                    (click)="toggleNewPasswordVisibility()"
                    tabindex="-1"
                  >
                    <i class="bi" [ngClass]="showNewPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                  </button>
                </div>
                <ul class="text-danger small mt-2">
                  <li [class.text-success]="hasMinLength">
                    {{ 'REGISTER_PASSWORD_MIN' | translate }}
                  </li>
                  <li [class.text-success]="hasUpperCase">
                    {{ 'REGISTER_PASSWORD_UPP' | translate }}
                  </li>
                  <li [class.text-success]="hasNumber">{{ 'REGISTER_PASSWORD_NO' | translate }}</li>
                  <li [class.text-success]="hasSpecialChar">
                    {{ 'REGISTER_PASSWORD_SPECIAL' | translate }}
                  </li>
                </ul>
                @if (formControls['password'].dirty && formControls['password'].invalid) {
                  <div class="invalid-feedback d-block">
                    {{ 'PASSWORD_REQUIRED' | translate }}
                  </div>
                }
              </div>

              <!-- Confirm Password -->
              <div class="mb-3">
                <label for="confirmPassword" class="form-label">{{
                  'NEW_PASSWORD_CONFIRM' | translate
                }}</label>
                <div class="input-group">
                  <input
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    formControlName="confirmPassword"
                    id="confirmPassword"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid': isSubmitted && formControls['confirmPassword'].invalid,
                    }"
                  />
                  <button
                    type="button"
                    class="btn btn-outline-secondary eye-slash-btn"
                    (click)="toggleConfirmPasswordVisibility()"
                    tabindex="-1"
                  >
                    <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                  </button>
                  @if (confirmPasswordControl?.invalid && confirmPasswordControl?.touched) {
                    <div class="invalid-feedback d-block">
                      @if (resetForm.errors?.['passwordsMismatch']) {
                        <div>{{ 'CONFIRM_PASSWORD_MISMATCH' | translate }}</div>
                      }
                      @if (confirmPasswordControl?.errors?.['required']) {
                        <div>{{ 'CONFIRM_PASSWORD' | translate }}</div>
                      }
                    </div>
                  }
                </div>
              </div>

              <!-- Submit -->
              <div class="mb-3 text-center">
                <button
                  type="submit"
                  class="btn btn-primary text-dark w-100"
                  [disabled]="resetForm.invalid || loading"
                  (click)="updatePassword()"
                >
                  @if (loading) {
                    <app-loading
                      class="align-content-center"
                      [height]="20"
                      theme="dark"
                    ></app-loading>
                  }
                  {{ 'PASSWORD_UPDATE_TITLE' | translate }}
                </button>
              </div>
            </form>
          }
        </div>
      </div>
    </div>
  </div>
</div>
